import { Columns3, LayoutList } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ColumnsTabPlaceholderProps {
  onSwitchToList: () => void;
}

export function ColumnsTabPlaceholder({ onSwitchToList }: Readonly<ColumnsTabPlaceholderProps>) {
  return (
    <div className="flex flex-col items-center justify-center h-full px-6 py-12">
      <div className="flex flex-col items-center text-center space-y-6 max-w-sm">
        {/* Icon */}
        <div className="relative">
          <div className="absolute inset-0 bg-primary/10 rounded-full blur-2xl" />
          <div className="relative bg-gradient-to-br from-primary/20 to-primary/5 rounded-full p-6">
            <Columns3 className="h-12 w-12 text-primary" />
          </div>
        </div>

        {/* Content */}
        <div className="space-y-3">
          <h3 className="text-lg font-semibold text-foreground">
            Column Configuration
          </h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Column customisation is only available in list view. Switch to list view to show, hide, and reorder columns.
          </p>
        </div>

        {/* Action Button */}
        <Button
          onClick={onSwitchToList}
          className="mt-2 gap-2"
          size="default"
        >
          <LayoutList className="h-4 w-4" />
          Switch to List View
        </Button>

        {/* Additional Info */}
        <div className="pt-4 border-t w-full">
          <p className="text-xs text-muted-foreground">
            In list view, you can drag and drop columns to reorder them and toggle their visibility.
          </p>
        </div>
      </div>
    </div>
  );
}
